export default {
  about: {
    zh: '关于',
    en: 'About',
    ja: 'MQTTXについて',
  },
  update: {
    zh: '检查更新',
    en: 'Check for Updates',
    ja: 'バージョンチェック',
  },
  web: {
    zh: '官方网站',
    en: 'Website',
    ja: '公式サイト',
  },
  support: {
    zh: '支持',
    en: 'Support',
    ja: 'サポート',
  },
  releases: {
    zh: '更新日志',
    en: 'Releases',
    ja: 'リリース履歴',
  },
  followGithub: {
    zh: '在 GitHub 上关注我们',
    en: 'Follow us on GitHub',
    ja: 'Githubでフォローする',
  },
  mqttToolkit: {
    zh: {
      emqLink: 'https://www.emqx.cn/',
      online: 'MQTT WebSocket Toolkit 是由 {0} 开源的支持浏览器访问的 MQTT 在线客户端工具。',
    },
    en: {
      emqLink: 'https://www.emqx.io/',
      online: 'MQTT WebSocket Toolkit is an MQTT online client tool that is open-sourced by {0}.',
    },
    ja: {
      emqLink: 'https://www.emqx.io/',
      online: 'MQTT WebSocket Toolkit is an MQTT online client tool that is open-sourced by {0}.',
    },
  },
  emqxDesc: {
    zh: '一款完全开源，高可用低时延的百万级分布式物联网 MQTT 5.0 消息服务器。',
    // tslint:disable-next-line:max-line-length
    en:
      'is a fully open source, highly scalable, highly available distributed MQTT 5.0 messaging broker for IoT, M2M and mobile applications.',
    ja: '完全なオープンソース、高可用性、低レイテンシのミリオンレベルの分散型IoT MQTT 5.0メッセージサーバ。',
  },
  emqxLocal: {
    zh: {
      emqx: 'EMQ X',
      local: '如需本地运行 MQTT Broker 推荐使用 {0}：',
    },
    en: {
      emqx: 'EMQ X',
      local: 'To run MQTT Broker locally, {0} is recommended. ',
    },
    ja: {
      emqx: 'EMQ X',
      local: 'ローカルでMQTT Brokerを利用するように{0}が薦められる',
    },
  },
  emqxDocker: {
    zh: '使用 Docker 安装 EMQ X：',
    en: 'Install EMQ X by using Docker:',
    ja: 'DockerでEMQ Xをインストール',
  },
}
